import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';

/**
 * PLAT-11991 — whether this showcase has translation languages set up: the
 * list the Brand Kit's language settings write, hydrated onto the organization
 * after the story loads (`VideoCreatorStore`). Before hydration it is unset and
 * reads as "none"; ContentView holds the tab's label hidden until it lands.
 * Read from an `observer`.
 */
export function useShowcaseHasLanguages(): boolean {
  const videoCreator = useVideoCreatorStore();
  return (videoCreator.organization?.supportedLanguages?.length ?? 0) > 0;
}
